import { useState, useRef } from 'react';
import { v4 as uuid } from 'uuid';

const useInput = (initialValue = '', type) => {
    const [value, setValue] = useState(initialValue);
    const { current: id } = useRef(uuid());
    const onChange = (e) => setValue(e.target.value);
    return { value, onChange, type, id };
};
export default useInput;